if (page === 'product'){
    let id = getParameterByName('id');
    let productRef = database.ref('products/' + id)
    productRef.on('value', productShot => {
        let product = productShot.val()
        $('.singleProduct-title').html(product.title)
        $('.singleProduct-description').html(product.description)
    })
}
